<div class="card">
  <h5 class="card-header">
    <div class="flex-between">
      <div>
        <button class="btn btn-light m-0" (click)="onBack()">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
          Lenses
        </button>
        <span class="selected-workload-name">{{ selectedLens?.lens_name }}</span>
      </div>
      <div class="flex-start">
        <button class="btn btn-light m-0" (click)="onRefresh()">
          <i class="fa fa-refresh"></i>
          Refresh
        </button>
      </div>
    </div>
  </h5>

  <div class="card-body">
    <div class="alert alert-danger" *ngIf="pillarsError">
      {{ pillarsError }}
    </div>

    <div class="text-center py-3" *ngIf="pillarsLoading">
      <img src="assets/img/loading_2.svg" alt="loading pillars" class="loader-icon" />
    </div>

    <table class="table table-docs" *ngIf="!pillarsLoading">
      <thead>
        <tr>
          <th>Sl. No.</th>
          <th>Pillar Name</th>
          <th class="center">Questions Answered</th>
          <th class="center">Score</th>
        </tr>
      </thead>
      <tbody *ngIf="pillars?.length > 0">
        <tr *ngFor="let pillar of pillars; let i = index">
          <td>{{ i + 1 }}</td>
          <td>
            <span class="nav-link cursor-pointer p-0" (click)="onOpenPillar(pillar)">
              {{ pillar.pillar_name }}
            </span>
          </td>
          <td class="center">{{ pillar.answered_label }}</td>
          <td class="center">{{ pillar.score_label }}</td>
        </tr>
      </tbody>
      <tbody *ngIf="pillars?.length === 0 && !pillarsError">
        <tr>
          <td colspan="4" class="center">No pillars found</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
